/**
 * noop
 *
 * @returns void
 */
export const noop = () => {};
